// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".activity-feedback-score--activityFeedbackScore--G49g3JU5 {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: flex-end;\n}\n.activity-feedback-score--activityFeedbackScore--G49g3JU5 .activity-feedback-score--scoreLabel--10aoVPwV {\n  color: #3f3f3f;\n  font-weight: bold;\n}\n", ""]);
// Exports
exports.locals = {
	"activityFeedbackScore": "activity-feedback-score--activityFeedbackScore--G49g3JU5",
	"scoreLabel": "activity-feedback-score--scoreLabel--10aoVPwV"
};
module.exports = exports;
